/* Veda Harvest – Clinical theme behaviours */
(() => {
  /* Lightning sale countdown: to a set end time, or to midnight every day */
  document.querySelectorAll('[data-vc-flash]').forEach((el) => {
    const pad = (n) => String(n).padStart(2, '0');
    const target = () => {
      const fixed = Date.parse(el.dataset.end || '');
      if (fixed && fixed > Date.now()) return fixed;
      const d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime();
    };
    let end = target();
    const tick = () => {
      let left = end - Date.now();
      if (left <= 0) { end = target(); left = end - Date.now(); }
      const s = Math.floor(left / 1000);
      el.querySelector('[data-h]').textContent = pad(Math.floor(s / 3600));
      el.querySelector('[data-m]').textContent = pad(Math.floor((s % 3600) / 60));
      el.querySelector('[data-s]').textContent = pad(s % 60);
    };
    tick(); setInterval(tick, 1000);
  });

  /* Key ingredient cards: "Name: what it does" -> card with bold name */
  document.querySelectorAll('[data-vc-ings]').forEach((box) => {
    const paras = [...box.querySelectorAll('p, li')].filter((p) => p.textContent.trim());
    const cards = [];
    paras.forEach((p) => {
      p.textContent.split(/\n+/).map((t) => t.trim()).filter(Boolean).forEach((line) => {
        const i = line.indexOf(':');
        cards.push(i > 0 && i < 48 ? { n: line.slice(0, i).trim(), d: line.slice(i + 1).trim() } : { n: '', d: line });
      });
    });
    if (!cards.length) return;
    box.innerHTML = '';
    cards.forEach((c, idx) => {
      const el = document.createElement('div');
      el.className = 'vc-ing';
      el.innerHTML = '<span class="vc-ing__num">' + String(idx + 1).padStart(2, '0') + '</span>' +
        (c.n ? '<strong class="vc-ing__name"></strong>' : '') + '<p class="vc-ing__text"></p>';
      if (c.n) el.querySelector('.vc-ing__name').textContent = c.n;
      el.querySelector('.vc-ing__text').textContent = c.d;
      box.appendChild(el);
    });
  });

  /* Variant boxes: show price, MRP, % off and per-unit price inside each pack option */
  const dataNode = document.querySelector('[data-vc-variants]');
  if (dataNode) {
    let variants = [];
    try { variants = JSON.parse(dataNode.textContent); } catch (e) {}
    const unit = (label, cents) => {
      const m = String(label).match(/(\d+(?:\.\d+)?)\s*(ml|gm|g|kg|l)\b/i);
      if (!m) return '';
      let qty = parseFloat(m[1]); let u = m[2].toLowerCase();
      if (u === 'gm') u = 'g';
      if (!qty) return '';
      const per = cents / 100 / qty;
      return '(₹' + (per >= 10 ? per.toFixed(1) : per.toFixed(2)) + '/' + u + ')';
    };
    const decorate = () => {
      document.querySelectorAll('.product-form__input--pill input[type=radio]').forEach((inp) => {
        const lbl = inp.id && document.querySelector('label[for="' + CSS.escape(inp.id) + '"]');
        if (!lbl || lbl.querySelector('.vc-vbox')) return;
        const v = variants.find((x) => x.o === inp.value);
        if (!v) return;
        const box = document.createElement('span');
        box.className = 'vc-vbox';
        box.innerHTML = '<span class="vc-vbox__price"><b></b>' + (v.off > 0 ? '<s></s><em></em>' : '') + '</span><span class="vc-vbox__unit"></span>';
        box.querySelector('b').textContent = v.p;
        if (v.off > 0) { box.querySelector('s').textContent = v.c; box.querySelector('em').textContent = v.off + '% off'; }
        box.querySelector('.vc-vbox__unit').textContent = unit(v.o, v.pc);
        lbl.classList.add('vc-vlabel');
        lbl.appendChild(box);
      });
    };
    decorate();
    const root = document.querySelector('.product__info-wrapper') || document.body;
    new MutationObserver(() => decorate()).observe(root, { childList: true, subtree: true });
  }
})();
